import React from 'react';
import './landingBottomCrd.css'

function C2wLandingBottomCrd( { obj, index} ){
  return (
    <div className='C2wLandingBottomCrd_card' style={{borderRight: index !== 3 ? '3.5px solid rgba(255, 255, 255, 0.5)' : 'none'}}>
        <p className='C2wLandingBottomCrd_card_count'>{obj?.count}+</p>
        <div className={`C2wLandingBottomCrd_card_subhead C2wLandingBottomCrd_card_subhead${index}`}  >{obj?.subHeading}</div>
    </div>
  )
}

export default C2wLandingBottomCrd;
